export const getQualityList = () => {
    return [
        {
            type: "包装",
            id: null,
            serialNum: 1,
            list: [
                {
                    title: "①有木架，纸箱完好，珍珠棉无缺失，机器没有侧放或倒置。",
                    describe: null,
                    qualified: null,
                    id: 1,
                },
                {
                    title: "②对照机器配件与钉钉的返厂流程是一致的",
                    describe: null,
                    qualified: null,
                    id: 2,
                },
                {
                    title: "③螺钉套件锁紧",
                    describe: null,
                    qualified: null,
                    id: 3,
                },
            ],
        },
        {
            type: "固定底座",
            id: null,
            serialNum: 2,
            list: [
                {
                    title: "①电源按键有声音反馈，按键灯正常，不得有摩擦等异常",
                    describe: null,
                    qualified: null,
                    id: 1,
                },
                {
                    title: "②DP外接屏幕显示正常。",
                    describe: null,
                    qualified: null,
                    id: 2,
                },
                {
                    title: "③下巴托电机无异响，下巴托无振动，摇摆幅度≤5mm。",
                    describe: null,
                    qualified: null,
                    id: 3,
                },
                {
                    title: "④风扇无异响",
                    describe: null,
                    qualified: null,
                    id: 4,
                },
                {
                    title: "⑤外壳不得有刮花、麻点、污点、变形、裂纹。",
                    describe: null,
                    qualified: null,
                    id: 5,
                },
            ],
        },
        {
            type: "运动底座",
            id: null,
            serialNum: 3,
            list: [
                {
                    title: "①手柄无跳动、无反转。",
                    describe: null,
                    qualified: null,
                    id: 1,
                },
                {
                    title: "②手柄外观不得有刮伤、碰伤。",
                    describe: null,
                    qualified: null,
                    id: 2,
                },
                {
                    title: "③手柄推力200±20g",
                    describe: null,
                    qualified: null,
                    id: 3,
                },
                {
                    title:
                        "④压锁按压顺滑，无明显阻尼感，按压无异响；压锁与固定底座壳接触面没有脏污和摩擦痕。",
                    describe: null,
                    qualified: null,
                    id: 4,
                },
                {
                    title: "⑤平台移动推力≤0.36kg",
                    describe: null,
                    qualified: null,
                    id: 5,
                },
                {
                    title: "⑥外壳不得有刮花、麻点、污点、变形、裂纹。",
                    describe: null,
                    qualified: null,
                    id: 6,
                },
            ],
        },
        {
            type: "主体",
            id: null,
            serialNum: 4,
            list: [
                {
                    title: "①样屏臂没有透光",
                    describe: null,
                    qualified: null,
                    id: 1,
                },
                {
                    title: "②小圆屏正常显示，声音可调节",
                    describe: null,
                    qualified: null,
                    id: 2,
                },
                {
                    title: "③参考臂电机无异响",
                    describe: null,
                    qualified: null,
                    id: 3,
                },
                {
                    title: "④光源无侧缝",
                    describe: null,
                    qualified: null,
                    id: 4,
                },
                {
                    title: "⑤风扇无异响",
                    describe: null,
                    qualified: null,
                    id: 5,
                },
                {
                    title: "⑥外壳：不得有刮花、麻点、污点、变形、裂纹。",
                    describe: null,
                    qualified: null,
                    id: 6,
                },
                {
                    title: "⑦滤光片：不得有刮花、麻点、污点、变形、裂纹。",
                    describe: null,
                    qualified: null,
                    id: 7,
                },
                {
                    title: "⑧防撕标签：无破损，无断裂",
                    describe: null,
                    qualified: null,
                    id: 8,
                },
            ],
        },
        {
            type: "拍摄",
            id: null,
            serialNum: 5,
            list: [
                {
                    title: "①开机或运行过程中没有出现报错的弹框提示",
                    describe: null,
                    qualified: null,
                    id: 1,
                },
                {
                    title: "②屏幕：触摸正常，无黑屏，无映射，无花屏，无漏光，无死机",
                    describe: null,
                    qualified: null,
                    id: 2,
                },
                {
                    title: "③WiFi连接正常",
                    describe: null,
                    qualified: null,
                    id: 3,
                },
                {
                    title: "④软件界面参数确认正常",
                    describe: null,
                    qualified: null,
                    id: 4,
                },
                {
                    title:
                        "⑤拍摄模拟眼工装（AL=24.31），数据准确，中心光斑在绿圈上下左右有稳定的双峰",
                    describe: null,
                    qualified: null,
                    id: 5,
                },
                {
                    title: "⑥模拟眼叠加的底噪正常：无侧峰，无干扰峰，无底噪增高＜10mm",
                    describe: null,
                    qualified: null,
                    id: 6,
                },
                {
                    title:
                        "⑦使用光功率计探头对准曲率灯板透镜或门透镜中心出光口，功率读数在0.5~0.6mW之间",
                    describe: null,
                    qualified: null,
                    id: 7,
                },
                {
                    title:
                        "⑧人眼拍摄速度正常，左右眼切换正常：600单峰周期<2，600P有效叠加周期≤60。（以下规格各拍摄1人，每人拍摄3次，2次达到检验标准即合格：200°以内、400°附近、600°以上。）",
                    describe: null,
                    qualified: null,
                    id: 8,
                },
            ],
        },
        {
            type: "其他",
            id: null,
            serialNum: 6,
            list: [
                {
                    title: "",
                    describe: null,
                    qualified: null,
                    id: 1,
                },
            ],
        },
        {
            type: "备注",
            id: null,
            serialNum: 7,
            list: [
                {
                    title: "",
                    describe: null,
                    qualified: false,
                    id: 1,
                },
            ],
        }
    ]
}

